import Immutable from "immutable";
import uniqBy from "lodash/uniqBy";
import View from "views/logic/views/View";
import isFilterInaccessible from "search-filter/logic/isFilterInaccessible";
const assertUnreachable = (type) => {
  throw new Error(`View type: ${type != null ? type : "(undefined)"} is not supported.`);
};
const getInaccessibleFiltersInView = (view, isPermitted) => {
  switch (view.type) {
    case View.Type.Search:
      return view.search.queries.flatMap(
        (query) => {
          var _a;
          return (_a = query.filters) == null ? void 0 : _a.filter((filter) => isFilterInaccessible(filter, isPermitted));
        }
      );
    case View.Type.Dashboard: {
      const inaccessibleFilter = view.search.queries.flatMap(
        ({ searchTypes }) => searchTypes.flatMap(
          ({ filters }) => filters == null ? void 0 : filters.filter((filter) => isFilterInaccessible(filter, isPermitted))
        )
      );
      return Immutable.OrderedSet(uniqBy(inaccessibleFilter.toArray(), (filter) => filter.id));
    }
    default:
      return assertUnreachable(view.type);
  }
};
export default getInaccessibleFiltersInView;
